<template>
  <h1 class="sr-only">Contact VORTEC</h1>
  <ClientOnly>
    <ContactForm />
  </ClientOnly>
</template>

<script lang="ts" setup>
useSeo({
  title: 'Contact | VORTEC',
  description:
    'Have a project in mind? Get in touch with VORTEC to discuss your idea, request a proposal, or book a free discovery call.',
  path: '/contact',
  jsonLd: {
    '@type': 'ContactPage',
    name: 'Contact | VORTEC',
    description: 'Get in touch with VORTEC to discuss your project.',
    url: 'https://vortec.io/contact',
  },
});
</script>
